module.exports = {"backend":"https://cellarium.tiits.se","user":"tiits","token":"mH@xzF&cys716kKEvps^lZG0Tp!^QX8c"}


//////////////////
// WEBPACK FOOTER
// ./src/resources/settings/prod.json
// module id = nTml
// module chunks = 1